var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',[_c('b-tag',{staticClass:"averta-bold font-custom",class:_vm.handleGetStatusClass(_vm.tagTitle),staticStyle:{"color":"#ffffff"},attrs:{"type":_vm.tagType,"rounded":""}},[_vm._v(" "+_vm._s(_vm.wordingHelper(_vm.tagTitle))+" "),(_vm.tagTitle === 'Menunggu Konfirmasi')?_c('i',{staticClass:"mdi mdi-information"}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }